var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { FormCoreComponent } from '../form-core';
var OrganisationPreferencesFormComponent = /** @class */ (function (_super) {
    __extends(OrganisationPreferencesFormComponent, _super);
    function OrganisationPreferencesFormComponent() {
        var _this = _super.call(this) || this;
        _this.shareCheckIns = new FormControl(false);
        _this.subs = [];
        _this.form = new FormGroup({
            severeConcernWarning: new FormControl(false, Validators.required),
            severeConcernMessage: new FormControl(false),
            autoShareLow: new FormControl(false, Validators.required),
            autoShareMid: new FormControl(false, Validators.required),
            autoShareHigh: new FormControl(false, Validators.required),
            autoShareSevere: new FormControl(false, Validators.required),
            minCheckInShareScore: new FormControl(-1, Validators.required),
            maxCheckInShareScore: new FormControl(-1, Validators.required),
        });
        _this.subs.push(_this.shareCheckIns.valueChanges.subscribe(function (share) { return _this.updateMinMaxCheckIns(); }));
        _this.subs.push(_this.form.valueChanges.subscribe(function (changes) { return _this.updateShareCheckIns(_this.form.value); }));
        return _this;
    }
    Object.defineProperty(OrganisationPreferencesFormComponent.prototype, "preferences", {
        set: function (value) {
            if (value) {
                this.form.patchValue(value, { emitEvent: false, onlySelf: true });
                this.updateShareCheckIns(value);
            }
        },
        enumerable: true,
        configurable: true
    });
    OrganisationPreferencesFormComponent.prototype.updateMinMaxCheckIns = function () {
        var opts = { emitEvent: false, onlySelf: true };
        var share = this.shareCheckIns.value;
        if (share) {
            this.form.patchValue({
                minCheckInShareScore: 0,
                maxCheckInShareScore: 3
            }, opts);
        }
        else {
            this.form.patchValue({
                minCheckInShareScore: -1,
                maxCheckInShareScore: -1
            }, opts);
        }
    };
    OrganisationPreferencesFormComponent.prototype.updateShareCheckIns = function (formValue) {
        var opts = { emitEvent: false, onlySelf: true };
        var values = { minCheckInShareScore: formValue.minCheckInShareScore, maxCheckInShareScore: formValue.maxCheckInShareScore };
        // Prevent values from getting out of whack (min > max or max > min)
        if (values.minCheckInShareScore > values.maxCheckInShareScore) {
            values.minCheckInShareScore = values.maxCheckInShareScore;
        }
        if (values.maxCheckInShareScore < values.minCheckInShareScore) {
            values.maxCheckInShareScore = values.minCheckInShareScore;
        }
        this.form.patchValue(values, opts);
        // Update the toggle slider (if server returns -1 for either value)
        if (formValue.maxCheckInShareScore === -1) {
            this.shareCheckIns.patchValue(false, opts);
        }
        else {
            this.shareCheckIns.patchValue(true, opts);
        }
    };
    OrganisationPreferencesFormComponent.prototype.ngOnDestroy = function () {
        this.subs.forEach(function (sub) { return sub.unsubscribe(); });
    };
    return OrganisationPreferencesFormComponent;
}(FormCoreComponent));
export { OrganisationPreferencesFormComponent };
